import messages from './messages.tsx';

const LEARN_MORE_TYPES = {
	IssueTypes: '#IssueTypes',
	PriorityLevels: '#PriorityLevels',
	ResolutionTypes: '#ResolutionTypes',
	SecurityLevels: '#SecurityLevels',
};

export const LEARN_MORE_MESSAGES_WITH_ISSUE_TERM = {
	[LEARN_MORE_TYPES.IssueTypes]: messages.fieldHelpIssueTypesIssueTermRefresh,
	[LEARN_MORE_TYPES.PriorityLevels]: messages.fieldHelpPriorityLevels,
	[LEARN_MORE_TYPES.ResolutionTypes]: messages.fieldHelpResolutionDefinitions,
	[LEARN_MORE_TYPES.SecurityLevels]: messages.fieldHelpSecurityLevels,
};

export const LEARN_MORE_MESSAGES = {
	[LEARN_MORE_TYPES.IssueTypes]: messages.fieldHelpIssueTypes,
	[LEARN_MORE_TYPES.PriorityLevels]: messages.fieldHelpPriorityLevels,
	[LEARN_MORE_TYPES.ResolutionTypes]: messages.fieldHelpResolutionDefinitions,
	[LEARN_MORE_TYPES.SecurityLevels]: messages.fieldHelpSecurityLevels,
};
